<template>
  <div class='wameed-dashboard-page-content'>
    <page-header
      :title="$t('ads.title')"

      :btn-title="$t('ads.new_btn')"

      :route-name="'ads-create'"
    />

    <div>
      <filter-header
        :content='filterContent'
        @applyFilter='applyFilter'
        @resetFilter='resetFilter'
        @orderApplicants='orderData'

      />
    </div>
    <section
      class='
        wameed-dashboard-page-content_body
        d-flex
        flex-column
        justify-content-between
        overflow-hidden
      '>
      <div class='d-flex flex-wrap flex-1'>
        <b-col lg='12' md='12' class='px-0'>

          <div class='w-table d-flex flex-column'>
            <w-tables
              :noDataTitle="$t('table.no_data_title')"
              :noDataSubtitle="$t('table.no_data_subtitle')"
              v-if='getData'
              :per-page='filterData.per_page'
              :items='getData'
              :fields='tableFields'
              :custimized-items="[
                { name: 'name' },
                { name: 'status' },
                { name: 'action' },
              ]"
            >

              <template slot='name' slot-scope='{ data }'>
                <name-tile
                  :name='data.item.name'
                  :image='data.item.image'
                />
              </template>


              <template slot='status' slot-scope='{ data }'>
                <wameed-switch
                  :disabled='data.item.disable ===1'
                  :checked='data.item.status ===1'
                  @onChange='(e)=>{e.preventDefault(); onChange(data.item)}' />
              </template>

              <template slot='action' slot-scope='{ data }'
                        v-if='data.item.type==null'>
                <b-dropdown
                  variant='background'
                  class='table-option'
                  toggle-class='text-decoration-none rounded-10 px-2 py-2 '
                  menu-class='rounded-8'
                  no-caret
                  dropleft
                >
                  <template v-slot:button-content>
                    <vertical-dots-icon />
                  </template>

                  <b-dropdown-item
                    class='permission-edit-item'
                    v-permission='[$route.meta.pagePermissions.edit]'
                    :to="goToUpdate(data.item.id)"
                  >
                    <span class='text-regular-14 text-font-secondary'>

                      <edit-icon class='mx-2' />
                      {{ $t('btn.edit') }}
                    </span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    class='permission-delete-item'
                    v-permission='[$route.meta.pagePermissions.delete]'
                    @click='deleteModal = true; modalData = data.item'>
                    <span class='text-regular-14  text-danger'>
                      <trash-icon class='mx-2 ' />
                      {{ $t('btn.delete') }}
                    </span>
                  </b-dropdown-item>

                </b-dropdown>
              </template>
            </w-tables>
          </div>

        </b-col>

        <b-col lg='12' md='12' class='px-0'>
          <wameed-pagination
            v-if='getTotal'
            v-model='filterData.page'
            :page='filterData.page'
            :total-items='getTotal.totalItems'
            :per_page='filterData.per_page'
            :menu-title="$t('common.show_results')"
            @changePage='changePage'
            @changeCurrentPage='changeCurrentPage'
          />
        </b-col>

      </div>

    </section>

    <ad-modal
      :visible='showModal'
      @close='showModal = false'
      :modal-data='modalData'
      @onComplete='()=>loadData()'
    ></ad-modal>


    <warning-modal
      variant='danger'
      iconName='trash-icon'
      :visible='deleteModal'
      @close='deleteModal = false'
      @submitAction='deleteAction'
      :title="$t('ads.modal.delete')"
      :subTitle="$t('ads.modal.delete_desc')"
      :btnTitle="$t('btn.delete')"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PageHeader from '@/components/wameed/WameedPageHeader.vue';
import FilterHeader from '@/components/wameed/WameedFilterHeader.vue';
import WarningModal from '@/components/WarningModal';

import { WameedPagination, WameedSwitch, WameedTables as WTables } from 'wameed-ui/dist/wameed-ui.esm';
import NameTile from '@/components/nameTile.table';
import AdModal from '@/views/pages/ads/components/adModal';
import { AdRedirectTypes } from '@/enums/userType.enum';
import { DiscountCategoryEnum } from '@/enums/discountCategory.enum';

export default {
  components: {
    AdModal,
    NameTile,
    WarningModal,
    WameedPagination,
    PageHeader,
    FilterHeader,
    WameedSwitch,
    WTables
  },
  data() {
    return {
      showModal: false,
      deleteModal: false,
      modalData: null,
      filterData: {
        status: '',
        page: 1,
        per_page: 20,
        order_by: 'desc',
        search: ''
      },
      filterContent: [
        {
          title: this.$i18n.t('table.availability'),
          key: 'status',
          id: 'id',
          name: 'title',
          selectedData: [],
          translate: true,
          type: 'text',
          data: [
            {
              id: 'active',
              title: this.$i18n.t('status.available')
            },
            {
              id: 'not_active',
              title: this.$i18n.t('status.not_available')
            }
          ]
        }
      ],
      tableFields: [
        {
          key: 'index',
          label: '#',
          sortable: false

        },
        {
          key: 'name',
          label: this.$i18n.t('ads.form.name'),
          sortable: false,
          tdClass: 'w-2/5'
        },
        {
          key: 'redirect',
          label: this.$i18n.t('ads.form.redirect'),
          sortable: false,
          tdClass: 'w-1/5'
        },

        {
          key: 'status',
          label: this.$i18n.t('table.availability'),
          sortable: false,
          tdClass: 'w-1/5'
        },
        {
          key: 'action',
          label: this.$i18n.t('table.options'),
          tdClass: 'w-1/5'
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      getData: 'admin/ads/getData',
      getTotal: 'admin/ads/getTotal'
    }),
  },
  created() {
    this.$store.dispatch('admin/ads/getVendors');
    this.loadData();
  },
  methods: {
    ...mapActions({
      _getData: 'admin/ads/get',
      _deleteData: 'admin/ads/delete'
    }),

    goToUpdate(id) {
      return {
        name: 'ads-update',
        params: {lang: this.$i18n.locale, id },
      };
    },

    async openUpdateModal(item) {
      if (item.vendor_id) {
        if (item.redirect_type === AdRedirectTypes.product) {
          await this.$store.dispatch('admin/ads/getProducts', item.vendor_id);
        } else if (item.redirect_type === AdRedirectTypes.package) {
          await this.$store.dispatch('admin/ads/getPackages', item.vendor_id);
        }
      }
      this.showModal = true;
      this.modalData = {
        id: item.id,
        name: item.name,
        image: { name: item.image },
        image_web: { name: item.image_web },
        redirect_type: item.redirect_type,
        redirect: item.redirect_to,
        vendor_id: item.vendor_id,
        start_at: item.start_at,
        end_at: item.end_at
      };
    },

    onChange(item) {
      let status = 1;
      if (item.status === 1) {
        status = 0;
      }

      this.$store.dispatch('admin/ads/toggle', { id: item.id, status: status });
    },

    changeCurrentPage(item) {
      this.filterData = {
        ...this.filterData,
        per_page: item.id,
        page: 1
      };
      this.loadData();
    },

    changePage(event) {
      this.filterData = {
        ...this.filterData,
        page: event
      };
      this.loadData();
    },

    loadData() {

      this._getData(this.filterData);
    },

    deleteAction() {
      this.deleteModal = false;
      this._deleteData({ id: this.modalData.id });
    },


    applyFilter() {
      this.filterContent.forEach(item => {
        this.filterData[item.key] = item.selectedData.toString();
      });
      this.loadData();
    },


    resetFilter() {
      this.filterContent.forEach((item, i) => {
        this.filterContent[i].selectedData = [];
        this.filterData[item.key] = item.selectedData.toString();
      });
      this.loadData();
    },


    orderData(item) {
      this.filterData = {
        ...this.filterData,
        ...item
      };
      this.loadData();
    }
  }
};
</script>
